<div [ngClass]="cascadeClasses">
    <div #expander class="esri-component"></div>
</div>
<slot #expanderContent></slot>
